'use strict'

import {
  Polymer
} from '@polymer/polymer/lib/legacy/polymer-fn.js'
import {
  dom,
  flush
} from '@polymer/polymer/lib/legacy/polymer.dom.js'
import {
  html
} from '@polymer/polymer/lib/utils/html-tag.js'
import '@polymer/iron-collapse/iron-collapse'
import '@polymer/paper-tooltip/paper-tooltip'
import '@polymer/iron-icons/av-icons'
import '@polymer/iron-icons/social-icons'
import '@polymer/iron-icons/editor-icons'
import '@polymer/iron-icons/image-icons'
import '@polymer/iron-iconset-svg/iron-iconset-svg'
import '@polymer/iron-iconset/iron-iconset'
import '@moskito/moskito-iconset/moskito-iconset'
import '@polymer/iron-icons/iron-icons'
import '@moskito/moskito-styles/moskito-styles'
Polymer({
  is: 'moskito-payment',
  _template: html`
<style include="iron-flex iron-flex-alignment moskito-styles">
:host  {
margin-top: 24px;
background: var(--paper-blue-grey-50);
padding: 1px 12px;
border-radius: 12px;
display: block;
}
a {
  text-decoration: none;
  color: var(--default-primary-color);
}
.hidden {
display: none;
}
.greyed {
  color: #aaa;
}
.accent-green {
  color: var(--paper-green-a700);
}
.icon {
margin-right: 12px;
}
</style>
<h3><iron-icon icon="icons:payment"></iron-icon> {{_translate('Payment')}}</h3>
            <div id="song_payment_[[payment.id]]" style="z-index:0;">
              <div class="horizontal layout" >
                <div class="icon">
                  <template is="dom-if" if="[[_isConfirmed(payment)]]">
                    <iron-icon class="accent-green" icon="icons:check"></iron-icon>
                  </template>
                  <template is="dom-if" if="[[_isNotConfirmed(payment)]]">
                    <iron-icon class="greyed" icon="icons:schedule"></iron-icon>
                  </template>
                </div>
                <div class="flex"><span class="accent">{{_translate('ID')}}</span> {{payment.uuid}} ({{payment.ext_id}})</div>
                <div class="flex"><span class="accent">{{_translate('Amount')}}</span> {{_formatMoney(payment.amount)}}</div>
                <div class="flex"><span class="accent">{{_translate('Payment Type') }}</span> <iron-icon icon="moskito-iconset:{{payment.meta.payment_type.code}}"></iron-icon> {{payment.meta.payment_type.name}}</div>
              </div>
              <div class="more">
                <div class="horizontal layout">
                  <div class="flex"><span class="accent">{{_translate('Purchase Date')}}</span> {{_formatDate(payment.time_purchased)}}</div>
                  <div class="flex"><span class="accent">{{_translate('Payment Date')}}</span> {{_formatDate(payment.time_paid)}}</div>
                </div>
                <template is="dom-if" if="{{editable}}">
                  <a href="/administration/payments/{{payment.id}}">
                    <paper-button>
                      <paper-icon-button icon="icons:create" ></paper-icon-button>{{_translate('Edit Payment')}}
                    </paper-button>
                  </a>
                </template>
                <a href="{{payment.invoice.url}}" target="_blank">
                  <paper-button>
                    <paper-icon-button icon="icons:receipt" ></paper-icon-button>{{_translate('View the Invoice')}}
                  </paper-button>
                </a>
              </div>
            </div>
`,
  properties: {
    payment: {
      type: Object,
      notify: true
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
  ready: function () {
  },
  isTranslation: function (title) {
    return title.original.language !== 'fr'
  },
  _translate: function (string) {
    return window.__(string)
  },
  _formatDate: function (date) {
    if (typeof date === 'string') {
      return date
    }
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    const d = new Date(date * 1000)
    return (d).toLocaleDateString('fr-FR', options)
  },
  _formatMoney: function (number) {
    if (typeof number !== 'number') {
      return ''
    }
    return number.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' })
  },
  _isConfirmed: function (item) {
    return item.confirmed
  },
  _isNotConfirmed: function (item) {
    return !this._isConfirmed(item)
  }
})
